export default __webpack_public_path__ + "static/ursula-approves-8b677208ff0e302ceefb2e368b3751ae.svg";